import { Checkout, PaymentMethod } from '../types/checkout.interface'

export const SESSION_STORAGE_CHECKOUT = '@parkdepot/checkout'

export const SESSION_STORAGE_setCheckout = (checkout: Checkout) => {
    sessionStorage.setItem(SESSION_STORAGE_CHECKOUT, JSON.stringify(checkout))
}

export const SESSION_STORAGE_getCheckout = (): Checkout | null => {
    const checkout = sessionStorage.getItem(SESSION_STORAGE_CHECKOUT)
    return checkout ? JSON.parse(checkout) : null
}

export const SESSION_STORAGE_setReferenceNumber = (referenceNumber: string) => {
    const checkout = SESSION_STORAGE_getCheckout()
    if (checkout) {
        checkout.bookingNo = referenceNumber
        SESSION_STORAGE_setCheckout(checkout)
    }
}

export const SESSION_STORAGE_setPaymentMethod = (paymentMethod: PaymentMethod) => {
    const checkout = SESSION_STORAGE_getCheckout()
    if (checkout) {
        checkout.paymentMethod = paymentMethod
        SESSION_STORAGE_setCheckout(checkout)
    }
}
